import { ValueDecoder } from './types';

export const decodeFloat: ValueDecoder = (value) => {
  if (/^(\d+|\d*\.\d+)$/.test(value)) {
    return parseFloat(value);
  }
  return value;
};
